var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{class:_vm.isFullscreen?'el-icon-full-screen':'el-icon-full-screen',on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }